import { defineRouting } from "next-intl/routing";
import { defaultLocale, getLocaleCookieOptions, locales } from "./config";

export const routing = defineRouting({
	locales,
	defaultLocale,
	localePrefix: "never",
	localeDetection: true,
	// Evaluated once at module import; tests that need environment-specific
	// cookie settings should call getLocaleCookieOptions directly.
	localeCookie: getLocaleCookieOptions(),
});
